import { formatDateTime } from 'src/pages/kds';
import '../../pages/kds/kds.css';
import { CurrencyAmount } from 'src/containers/currency';

export const FinalBillPrintProv = (
  props: any,
  orderInfo: any,
  currentUser: any,
  businessName: string,
  businessAddress: any,
  panNumber: string | number,
  possiblePaymentMethod?: string
) => {
  const getItemizedDiscount = orderInfo?.customDiscountInfo?.individualItemAmount ?? 0;
  const getWholeDiscount = orderInfo?.customDiscountInfo?.amount ?? 0;

  const getTotal = () => {
    return orderInfo?.total
  };

  const renderDiscountInfoTotal = () => {
    const totalDiscount = getItemizedDiscount;
    if(totalDiscount === 0) return;

    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: '12px',
          lineHeight: '14px',
          marginBottom: '3px',
        }}
      >
        <span>Itemized Discount</span>
        <span><CurrencyAmount amount={totalDiscount}/></span>
      </div>
    );
  };

  const renderDiscountInfoTotalWhole = () => {
    const totalDiscount = getWholeDiscount;
    if (totalDiscount === 0) return;

    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: '12px',
          lineHeight: '14px',
          marginBottom: '3px',
        }}
      >
        <span>Applied Discount</span>
        <span><CurrencyAmount amount={totalDiscount}/></span>
      </div>
    );
  };

  return (
    <div>
      <div
        id={`finalBillPrintProv`}
        className="hidden"
        style={{ fontFamily: 'Arial' }}
      >
        <div
          className="w-[100%] h-[100%]"
          style={{
            display: 'flex',
            flexDirection: 'column',
            fontFamily: 'Arial',
            fontWeight: '400',
          }}
        >
          <div
            className="d-flex flex-column"
            style={{ fontFamily: 'Arial', fontWeight: '400' }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <span
                style={{
                  fontSize: '16px',
                  lineHeight: '18px',
                  marginBottom: '5px',
                  textTransform: 'uppercase',
                }}
              >
                {businessName}
              </span>
              <span
                style={{
                  fontSize: '12px',
                  lineHeight: '14px',
                  marginBottom: '5px',
                  textTransform: 'uppercase',
                }}
              >
                {businessAddress?.area} {businessAddress?.city}
              </span>
              {panNumber && (
                <span
                  style={{
                    fontSize: '12px',
                    lineHeight: '14px',
                    marginBottom: '5px',
                    textTransform: 'uppercase',
                  }}
                >
                  PAN : {panNumber}
                </span>
              )}
              <span
                style={{
                  fontSize: '12px',
                  lineHeight: '14px',
                  marginBottom: '5px',
                  textTransform: 'uppercase',
                }}
              >
                Provisional Bill
              </span>
            </div>
            <span
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '10px',
                fontSize: '12px',
                lineHeight: '14px',
                marginBottom: '5px',
              }}
            >
              <span>Time: {formatDateTime(new Date())}</span>
            </span>
            <span
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '10px',
                fontSize: '12px',
                lineHeight: '14px',
                marginBottom: '5px',
              }}
            >
              <span>Table No. : {props?.table?.name || props?.tableName}</span>
            </span>
            <span
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: '10px',
                fontSize: '12px',
                lineHeight: '14px',
                marginBottom: '5px',
              }}
            >
              <span>
                Bill To : {currentUser?.name || currentUser?.phone || ''}{' '}
              </span>
            </span>
            {possiblePaymentMethod && (
              <span
                style={{
                  fontSize: '12px',
                  lineHeight: '14px',
                }}
              >
                Payment Method : {possiblePaymentMethod}
              </span>
            )}
            <div
              style={{
                display: ' grid',
                gridTemplateColumns: 'repeat(6, 1fr)',
                marginBottom: '10px',
                marginTop: '10px',
                paddingTop: '10px',
                fontSize: '12px',
                lineHeight: '14px',
                borderTop: '2px solid #000',
                textTransform: 'uppercase',
              }}
            >
              <div style={{ gridColumn: 'span 3' }}>Item</div>
              <div>Qty</div>
              <div>Rate</div>
              <div>Total</div>
            </div>

            <div style={{}}>
              {props?.items?.map((each: any, i: number) => {
                return (
                  <div
                    style={{
                      display: ' grid',
                      gridTemplateColumns: 'repeat(6, 1fr)',
                      marginBottom: '10px',
                      fontSize: '12px',
                      lineHeight: '14px',
                    }}
                  >
                    <div style={{ gridColumn: 'span 3' }}>
                      {each.hasVariants
                        ? `${each.name} (${each.variantName})`
                        : `${each.name}`}{' '}
                      {each.selectedModifiers &&
                      each.selectedModifiers.length > 0 ? (
                        <div
                          style={{
                            marginLeft: '10px',
                          }}
                        >
                          {each.selectedModifiers.map((mod: any, i: any) => (
                            <div
                              key={i}
                              style={{
                                marginLeft: '10px',
                                marginTop: '5px',
                              }}
                            >
                              <span
                                style={{
                                  fontWeight: '500',
                                }}
                              >
                                {mod.name}
                              </span>
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  marginLeft: '10px',
                                }}
                              >
                                {mod?.options?.map(
                                  (eachOp: any, indOp: number) =>
                                    eachOp.hasSelected && (
                                      <div
                                        key={mod.name + indOp + eachOp.name}
                                        style={{
                                          display: eachOp.hasSelected
                                            ? 'flex'
                                            : 'hidden',
                                        }}
                                      >
                                        {eachOp.name}
                                      </div>
                                    )
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        ''
                      )}
                      {each?.spiceLevel && (
                        <div
                          style={{
                            display: 'flex',
                            marginLeft: '10px',
                            marginTop: '5px',
                          }}
                        >
                          <span>Spice level - </span>
                          <span>{each.spiceLevel}</span>
                        </div>
                      )}
                    </div>
                    <div>{each.quantity}</div>
                    <div>{each.price / each.quantity}</div>
                    <div>{each.price}</div>
                  </div>
                );
              })}
            </div>
            <div
              style={{
                margin: '10px 0',
                borderTop: '2px solid #000',
              }}
            />
            {orderInfo?.subTotal && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  fontSize: '12px',
                  lineHeight: '14px',
                  marginBottom: '3px',
                }}
              >
                <span>Subtotal</span>
                <span><CurrencyAmount amount={orderInfo?.subTotal}/></span>
              </div>
            )}
            {renderDiscountInfoTotal()}
            {renderDiscountInfoTotalWhole()}
            <hr className='text-primary-light'/>
            {orderInfo?.taxTotal > 0 && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  fontSize: '12px',
                  lineHeight: '14px',
                  marginBottom: '3px',
                }}
              >
                <span>Total tax</span>
                <span><CurrencyAmount amount={orderInfo?.taxTotal}/></span>
              </div>
            )}
            {orderInfo?.total >= 0 && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  fontWeight: '700',
                  fontSize: '14px',
                  lineHeight: '18px',
                  marginBottom: '3px',
                }}
              >
                <span>Total</span>
                <span><CurrencyAmount amount={getTotal().toFixed(2)}/></span>
              </div>
            )}
            <div
              style={{
                margin: '10px 0',
                borderTop: '1px solid #000',
              }}
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '20px',
              }}
            >
              <span style={{ fontSize: '10px', fontWeight: 600 }}>
                THANK YOU FOR YOUR ORDER
              </span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <span style={{ fontSize: '10px', fontWeight: 600 }}>
                PLEASE VISIT US AGAIN ☺
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
